import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class CustomerLeadsProvider extends BaseApi {
	async checkFollowupDate(): Promise<Record<string, any>> {
		return this.post(`/${DMS_MODULE}/${NAME}/CheckFollowupDate`);
	}
}

export const apiProvider = new CustomerLeadsProvider(DMS_MODULE, NAME);
